import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { nextStep } from '../../action/SpinToWinAction';
import { IconClock, IconTrophy, IconCalendar } from '../Images';
import SpinButton from '../SpinButton/SpinButton';
import SpinHeader from '../SpinHeader';
import { PRIZES } from '../../constant/prizes';
import SpinWheel from '../SpinWheel';
import classes from './HowItWorks.module.css';

const STEPS = [
  { number: 1, label: 'SPIN TO GET TARGET PRICE', img: '/images/how-step-1.png', alt: 'Spin wheel' },
  { number: 2, label: 'BUILD YOUR RING IN 60 SECONDS', img: '/images/how-step-2.png', alt: 'Ring parts' },
  { number: 3, label: 'COMPLETE YOUR SUBMISSION', img: '/images/how-step-3.png', alt: 'Completed ring' },
];

const INFO = [
  { icon: IconClock,    title: '60 SECONDS TO COMPLETE', desc: "You have 60 seconds to create your ring. Time's up and you're out of the challenge!" },
  { icon: IconTrophy,   title: '3 LUCKY WINNERS',        desc: 'Three closest to their target will win amazing prizes!' },
  { icon: IconCalendar, title: 'WINNER ANNOUNCED',       desc: 'Today at 4 PM at the HK/Craft booth. Please make sure to be there!' },
];

interface HowItWorksProps {
  isActive?: boolean;
  onNextTransition?: () => void;
}

const HowItWorks: FC<HowItWorksProps> = ({ isActive, onNextTransition }) => {
  const dispatch = useDispatch();

  // Fade in as Spin Intro finishes fading out, so the handover is smooth instead
  // of a hard cut. Also clears the opacity:0 the 1 → 2 crossfade leaves behind.
 /* useEffect(() => {
    if (!isActive) return;
    gsap.set('.gsap-hw-wheel', { clearProps: 'opacity' });
    gsap.fromTo('.gsap-hw-root', { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'power2.out' });
  }, [ isActive ]);*/

  const handleNext = () => {
    if (onNextTransition) onNextTransition();
    else dispatch(nextStep());
  };

  return (
    <div className={`${classes.root} gsap-hw-root`}>
      <div className={`${classes.headerContainer} hw-header`}>
        <SpinHeader/>
      </div>

      <h1 className={classes.title}>HOW IT WORKS!</h1>

      <div className={classes.stepsRow} data-wheel-row>
        {STEPS.map((step, index) => (
          <div key={step.number} className={classes.step}>
            {index !== STEPS.length - 1 &&
              <div className={classes.connector} style={{ left: '50%', transform: 'translateX(0%)' }}/>}
            <div className={classes.stepNumber}>{step.number}</div>
            <p className={classes.stepLabel}>{step.label}</p>
            {step.number === 1
              ? (
                <div className="gsap-hw-wheel" style={{ display: 'inline-block' }}>
                  <SpinWheel spinMs={200} spinning={false} rotation={0} size={350}/>
                </div>
              )
              : <img src={step.img} alt={step.alt} className={classes.stepImg}/>
            }
          </div>
        ))}
      </div>

      {/* Next button */}
      <div className={classes.btnRow}>
        <SpinButton onClick={handleNext} className="gsap-primary-btn-next">
          Next
        </SpinButton>
      </div>

      {/* Info bar */}
      <div className={classes.infoBar}>
        {INFO.map((item) => (
          <div key={item.title} className={classes.infoItem}>
            <img src={item.icon} alt={item.title} className={classes.infoIcon}/>
            <p className={classes.infoTitle}>{item.title}</p>
            <p className={classes.infoDesc}>{item.desc}</p>
          </div>
        ))}

        {/* Prizes — podium order comes from the shared PRIZES constant */}
        {PRIZES.map(({ rank, badge, image, label, featured },index) => (
          <div
            key={rank}
            className={`${classes.prizeCard}${featured ? ` ${classes.prizeCardFeatured}` : ''}`}
          >
            <img src={badge} alt={rank} className={classes.prizeBadge} draggable={false}/>
            <img src={image} alt={label} className={`${classes.prizeImage} ${index === PRIZES.length -1 ? "!scale-[1.1]" :""}`} draggable={false}/>
            <p className={classes.prizeLabel}>{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
